import React from "react";
import {
  Button, Checkbox, HStack, Menu, MenuButton, MenuList, MenuItem,
  MenuDivider, Text,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useFaxInboxSchemas } from "../../hooks/useFaxInboxSchemas";

/**
 * Which schemas' faxes the inbox shows — the Providers dropdown, for faxes.
 *
 * Chakra rather than Tailwind on purpose: AdminPage renders outside
 * `#clinic-root`, and this app's Tailwind is scoped to that subtree, so a
 * utility-class version would come out unstyled here.
 *
 * Hidden entirely for a single-schema clinic — there is nothing to choose.
 */
export default function FaxSchemaFilter({ onChange }) {
  const { allSchemas, homeSchema, selected, isSelected, toggle, selectAll, clearToHome } =
    useFaxInboxSchemas();

  if (!allSchemas || allSchemas.length <= 1) return null;

  const all = selected.length === allSchemas.length;
  const label = all
    ? `All schemas (${allSchemas.length})`
    : `${selected.length} of ${allSchemas.length} schemas`;

  const act = (fn) => (...args) => {
    fn(...args);
    // The parent refetches; the hook's own state is the source of truth and
    // this is just the nudge.
    onChange?.();
  };

  return (
    <Menu closeOnSelect={false} placement="bottom-end">
      <MenuButton
        as={Button}
        size="sm"
        variant="outline"
        rightIcon={<ChevronDownIcon />}
        fontWeight="semibold"
      >
        🏥 {label}
      </MenuButton>
      <MenuList minW="240px" maxH="60vh" overflowY="auto" zIndex={2000}>
        <HStack px={3} py={1} spacing={3}>
          <Button size="xs" variant="link" onClick={act(selectAll)}>
            Select all
          </Button>
          <Button size="xs" variant="link" onClick={act(clearToHome)}>
            Just mine
          </Button>
        </HStack>
        <MenuDivider />
        {allSchemas.map((s) => (
          <MenuItem key={s} onClick={act(() => toggle(s))} closeOnSelect={false}>
            <Checkbox
              isChecked={isSelected(s)}
              pointerEvents="none"
              isReadOnly
              mr={2}
            />
            <Text fontSize="sm">{s === homeSchema ? `${s} (mine)` : s}</Text>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
